import React, { useState } from 'react';
import { testimonials } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';
import { Button } from './ui/button';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const bgColor = '#1a2332';
  const accentColor = '#d4af37';

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-20 text-white" style={{ backgroundColor: bgColor }}>
      <div className="container mx-auto px-6">
        <div className="mb-16 text-center">
          <h2 className="mb-4 font-serif text-4xl font-bold md:text-5xl">What Others Say</h2>
          <div className="mx-auto h-1 w-24 rounded" style={{ backgroundColor: accentColor }}></div>
          <p className="mx-auto mt-6 max-w-3xl text-lg text-white opacity-90">
            Testimonials from clients, colleagues, and team members
          </p>
        </div>

        <div className="relative mx-auto max-w-4xl">
          <Card className="border-none bg-white/5 backdrop-blur-sm">
            <CardContent className="p-8 md:p-12">
              <Quote className="mb-6 h-12 w-12 opacity-30" style={{ color: accentColor }} />
              
              <div className="mb-6 flex">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-current" style={{ color: accentColor }} />
                ))}
              </div>

              <p className="mb-8 text-xl leading-relaxed text-white md:text-2xl">
                "{currentTestimonial.text}"
              </p>

              <div className="flex items-center justify-between">
                <div>
                  <p className="text-lg font-semibold" style={{ color: accentColor }}>
                    {currentTestimonial.name}
                  </p>
                  <p className="text-sm text-white opacity-70">{currentTestimonial.role}</p>
                  <p className="text-sm font-medium text-white">{currentTestimonial.company}</p>
                </div>

                <div className="flex gap-2">
                  <Button
                    onClick={prevTestimonial}
                    variant="outline"
                    size="icon"
                    className="rounded-full border-white/30 bg-white/10 text-white hover:bg-white/20"
                  >
                    <ChevronLeft className="h-5 w-5" />
                  </Button>
                  <Button
                    onClick={nextTestimonial}
                    variant="outline"
                    size="icon"
                    className="rounded-full border-white/30 bg-white/10 text-white hover:bg-white/20"
                  >
                    <ChevronRight className="h-5 w-5" />
                  </Button>
                </div>
              </div>

              <div className="mt-6 flex justify-center gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className="h-2 w-2 rounded-full transition-all"
                    style={{
                      backgroundColor: index === currentIndex ? accentColor : 'rgba(255,255,255,0.3)',
                      width: index === currentIndex ? '2rem' : '0.5rem'
                    }}
                  />
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
